module.exports = __webpack_public_path__ + "static/get_in_touch-1df5da87eee265be6102472fc8dec58a.jpg";